import { useMemo, useRef } from 'react'
import { SGeneralForms, SLocalSelected } from 'shj-components'
import { Select } from 'antd'

type IProps = {
  formRef: any
  fn: (data: any[]) => void
  config: any[]
}

export const SKUConfigure = (props: IProps) => {
  const { config, fn, formRef } = props
  const ref = useRef()

  const onFormRef = () => {
    const { onFormRef } = ref.current || {}
    return onFormRef?.()
  }

  const dealData = (item: Record<string, any>) => {
    console.log(item, 'item')
    return {
      spanCol: 24,
      label: item.label,
      name: item.value,
      required: true,
      rules: [{ required: true, message: `${item.label}不能为空` }],
      children: (
        <Select
          placeholder={`请选择${item.label}`}
          mode={'multiple'}
          onChange={v => {
            onFormRef()?.setFieldValue(item.value, v)
          }}
          options={item.data}
        />
      ),
    }
  }

  const formConfig = useMemo(() => {
    const initValues = {}
    console.log(config, 'config初始参数')
    const formItems = config.reduce((res, item) => {
      initValues[item.value] = item.data.map((el: any) => {
        return el.valueId || el.value
      })
      const item_ = dealData({ ...item })
      res.push(item_)
      return res
    }, [])
    console.log(initValues, 'initValues')

    return { formItems, initValues }
  }, [config])

  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      onFormRef()
        .validateFields()
        .then(values => {
          fn({ ...values })
          resolve({ ...values })
        })
        .catch(reject)
    })
  }

  if (formRef) {
    formRef.current.onFinish = onFinish
  }

  return (
    <SGeneralForms
      ref={ref}
      initialValues={formConfig.initValues}
      layout={'vertical'}
      configs={[
        {
          formItem: formConfig.formItems,
        },
      ]}
    />
  )
}
